import React from "react";
import parse from "html-react-parser";
import DOMPurify from "dompurify";
import { safeHref } from "../../utilities/utils";

function LibertySorryComponent(props) {

  return (
    <React.Fragment>
                  <p className="eca-switchoff-summary1">
                    {parse(DOMPurify.sanitize(props.utilityLabel1.utilityLabel.switchoffSummary1))}
                    <span style={{ whiteSpace: "nowrap" }}>
                      <a
                        href={
                          safeHref(props.utilityLabel1.utilityLabel.switchoffPhoneHref)
                        }
                        id="IVRPhone"
                        onClick={() =>
                          props.trackEvents("IVRSorry", "IVRPhone", props.sessionID)
                        }
                        className="underlined"
                        title={"Call "+props.propIvrPhone}
                        aria-label={"Call "+props.propIvrPhone}
                      >
                        <u>{props.propIvrPhone}</u>
                      </a>
                      .
                    </span>
                  </p>

                  <p className="eca-switchoff-summary2">
                    {parse(DOMPurify.sanitize(props.utilityLabel1.utilityLabel.switchoffSummary2))}
                    <a href={safeHref(props.utilityLabel1.utilityLabel.hrefEnroll)}
                      id="enroll"
                      onClick={() => props.trackEvents("IVRSorry", "Enroll", props.sessionID)}
                      className="underlined"
                      title="Click this link to navigate Enroll page."
                    >
                      {props.utilityLabel1.utilityLabel.enrollNowThankyou}
                    </a>
                    {" "}
                    {props.utilityLabel1.utilityLabel.or}
                    <a href={safeHref(props.utilityLabel1.utilityLabel.hrefSignOn)}
                      id="signOn"
                      onClick={() => props.trackEvents("IVRSorry", "SignOn", props.sessionID)}
                      className="underlined"
                      title="Click this link to navigate SignOn page."
                    >
                      {props.utilityLabel1.utilityLabel.signOnSorry}
                    </a>
                  </p>
                </React.Fragment>
  );
}

export default LibertySorryComponent;
